import React from "react";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import TaskStatusChip from "@src/multiCustodian/pages/Advisor/Tasks/TaskStatusChip/TaskStatusChip";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import Text from "@src/sharedComponents/Typography/Text";

import { OnboardingTaskCardProps } from "./types";

import styles from "./OnboardingTaskCard.module.css";

const OnboardingTaskCard: React.FC<OnboardingTaskCardProps> = ({
  task,
  disabled = false,
  onClick,
}) => {
  const handleClick = () => {
    if (!disabled && onClick) {
      onClick(task);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      className={toClassName(styles.container, {
        [styles.containerDisabled]: disabled,
      })}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
    >
      <div className={styles.leftContent}>
        <Text variant="bodyBold" color="text" className={styles.title}>
          {task.title}
        </Text>
        <ChevronRightIcon className={styles.chevronIcon} />
      </div>
      <TaskStatusChip taskStatus={task.taskStatus} />
    </div>
  );
};

export default OnboardingTaskCard;
